import { render, staticRenderFns } from "./SecondToolbarComponent.vue?vue&type=template&id=2a6872ae&scoped=true"
import script from "./SecondToolbarComponent.vue?vue&type=script&lang=ts"
export * from "./SecondToolbarComponent.vue?vue&type=script&lang=ts"
import style0 from "./SecondToolbarComponent.vue?vue&type=style&index=0&id=2a6872ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6872ae",
  null
  
)

export default component.exports